import { Loader2, RefreshCw } from 'lucide-react';
import { useHealth, useConfig } from '../hooks/useHealth';
import { useReload } from '../hooks/useAgents';
import { StatCard } from '../components/StatCard';

export function SystemPage() {
  const { data: health, isLoading: hLoading } = useHealth();
  const { data: config, isLoading: cLoading } = useConfig();
  const reload = useReload();

  if (hLoading || cLoading) {
    return <div className="flex items-center justify-center py-20"><Loader2 className="w-5 h-5 text-zinc-600 animate-spin" /></div>;
  }

  return (
    <div className="space-y-6">
      {/* Stats */}
      {health && (
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <StatCard label="Agents" value={health.agents} />
          <StatCard label="Mesh Agents" value={health.mesh.agents} />
          <StatCard label="Memory (RSS)" value={`${health.memory.rss}MB`} />
          <StatCard label="Uptime" value={`${Math.round(health.uptime / 60)}m`} />
        </div>
      )}

      {/* Config */}
      <section className="bg-surface border border-border rounded-lg p-4">
        <h3 className="text-xs font-semibold text-zinc-400 uppercase tracking-wide mb-3">Configuration</h3>
        <div className="space-y-2 text-xs">
          <Row label="Workspace" value={config?.workspace} />
          <Row label="Default Model" value={config?.defaultModel} />
          <Row label="Node" value={health?.nodeVersion} />
          <Row label="PID" value={String(health?.pid ?? '')} />
          <Row label="Agents" value={health?.agentNames.join(', ')} />
        </div>
      </section>

      {/* Actions */}
      <section className="bg-surface border border-border rounded-lg p-4">
        <h3 className="text-xs font-semibold text-zinc-400 uppercase tracking-wide mb-3">Actions</h3>
        <div className="flex gap-2">
          <button
            onClick={() => reload.mutate()}
            disabled={reload.isPending}
            className="flex items-center gap-1.5 px-3 py-2 text-xs border border-border rounded-lg hover:border-zinc-500 transition-colors disabled:opacity-50"
          >
            {reload.isPending ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />}
            Reload Agents from Disk
          </button>
        </div>
        {reload.data && (
          <p className="text-[11px] text-emerald-400 mt-2">{reload.data.message} ({reload.data.agents} loaded)</p>
        )}
      </section>
    </div>
  );
}

function Row({ label, value }: { label: string; value?: string }) {
  return (
    <div className="flex items-baseline gap-4">
      <span className="text-zinc-500 w-28 shrink-0">{label}</span>
      <span className="text-zinc-300 font-mono text-[11px] break-all">{value || '—'}</span>
    </div>
  );
}
